﻿interface KnockoutBindingHandlers {
	slideVisible: KnockoutBindingHandler;
	fadeVisible: KnockoutBindingHandler;
	fadeText: KnockoutBindingHandler;
	currency: KnockoutBindingHandler;
	allowBindings: KnockoutBindingHandler;
}

interface Number {
	toBankersRounding(decimalPlaces: number): number;
	formatMoney(decimalPlaces: number, centsSeparator?: string, thousandsSeparator?: string, moneySign?: string): string;
}

interface NumberConstructor {
	toMoney(num: any): string;
}

(function () {
	ko.bindingHandlers.slideVisible = {
		init: function (element, valueAccessor) {
			// First get the latest data that we're bound to
			var value = valueAccessor();

			// Next, whether or not the supplied model property is observable, get its current value
			var valueUnwrapped = ko.unwrap(value);

			// Now manipulate the DOM element
			if (valueUnwrapped == true)
				$(element).show(); // Make the element visible
			else
				$(element).hide();   // Make the element invisible
		},
		update: function (element, valueAccessor, allBindings) {
			// First get the latest data that we're bound to
			var value = valueAccessor();

			// Next, whether or not the supplied model property is observable, get its current value
			var valueUnwrapped = ko.unwrap(value);

			// Grab some more data from another binding property
			var duration = allBindings.get('slideDuration') || 400; // 400ms is default duration unless otherwise specified

			// Now manipulate the DOM element
			if (valueUnwrapped == true)
				$(element).slideDown(duration); // Make the element visible
			else
				$(element).slideUp(duration);   // Make the element invisible
		}
	};

	ko.bindingHandlers.fadeVisible = {
		update: (element, valueAccessor, allBindings) => {
			let value = ko.unwrap(valueAccessor());

			$(element)[value ? "fadeIn" : "fadeOut"](allBindings.get("fadeDuration") || 400)
		}
	}

	ko.bindingHandlers.fadeText = {
		update: (element, valueAccessor, allBindings, ...args) => {
			let $element = $(element),
				value = ko.unwrap(valueAccessor()),
				duration = ko.unwrap(allBindings.get("fadeDuration")) || 200;

			$element.css({
				"min-width": $element.width()
			});

			$element.fadeOut(duration, () => {
				ko.bindingHandlers.text.update.call(this, element, () => ko.unwrap(value.text || value), allBindings, ...args);

				$element.fadeIn(duration, () => {
					$element.css({
						"min-width": ""
					});
				});
			});
		}
	}

	ko.bindingHandlers.allowBindings = {
		init: function (elem, valueAccessor) {
			// Let bindings proceed as normal *only if* my value is false
			var shouldAllowBindings = ko.unwrap(valueAccessor());
			return { controlsDescendantBindings: !shouldAllowBindings };
		}
	};

	ko.bindingHandlers.currency = {
		update: function (element, valueAccessor, allBindings, data, context) {
			var valueUnwrapped = ko.unwrap(valueAccessor());
			var newValueAccessor = function () {
				return Number.toMoney(valueUnwrapped);
			};
			ko.bindingHandlers.text.update(element, newValueAccessor, allBindings, data, context);
		}
	};

	ko.virtualElements.allowedBindings["currency"] = true;
	ko.virtualElements.allowedBindings["allowBindings"] = true;
})();
